import React from 'react';

import styled from 'styled-components';

import media from 'apps/auth/theme/media';

export const Container = styled.ul`
    display: flex;
    padding: 20px 8px;
    border-top: 1px solid ${(props) => props.theme.grey_28_tr};
    border-bottom: 1px solid ${(props) => props.theme.grey_28_tr};
    margin: 0 -24px;

    ${media.tablet720} {
        padding: 24px 16px;
    }

    li {
        flex: 1;
    }
`;

export const List = (props) => {
    return <Container>{props.children}</Container>;
};
